<div class="header" fxLayout="row" fxLayoutAlign="space-between center">
	<div class="description" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
		<button class="back" mat-icon-button (click)="datasetRS.record.next(null);" *ngIf="datasetRS.record.value">
			<mat-icon>arrow_back_ios</mat-icon>
		</button>
		<span class="material-icons-outlined">directions_bus_filled</span>
		<span class="label" *ngIf="!datasetRS.record.value">{{'Risorse' | translate}}</span>
		<span class="label" *ngIf="datasetRS.record.value">{{ datasetRS.record.value.trip_resource.full_description || datasetRS.record.value.trip_resource.description }}</span>
	</div>

	<div class="close-icon" fxLayout="row" fxLayoutAlign="end center">
		<span class="material-icons-outlined dialog-close-icon" (click)="onCloseClick()">close</span>
	</div>
</div>

<div class="trip-booking-resource-container">
	<ng-container *ngIf='!datasetRS.record.value'>
		<ng-container *ngFor='let bookingPackage of data.tripBookingPackages'>
			<div class="actual_trip" fxLayout='row' fxLayoutAlign="start center" fxLayoutGap="8px">
				<ng-container *ngIf='bookingPackage.actual_trip.type'>
					<ng-container *ngIf='["going", "single"].includes(bookingPackage.actual_trip.type)'>
						<span class="going_trip">
							<img src="assets/icons/material-icons/filled/going_trip_icon.svg" />
						</span>
					</ng-container>
					<ng-container *ngIf='["return"].includes(bookingPackage.actual_trip.type)'>
						<span class="return_trip">
							<img src="assets/icons/material-icons/filled/return_trip_icon.svg" />
						</span>
					</ng-container>
				</ng-container>
				<span class="display_name">{{ bookingPackage.actual_trip.display_name }}</span>
				<span class="date">{{ bookingPackage.actual_trip.start_day | date:'dd/MM/yyyy' }}</span>
				<span class="hour" *ngIf='bookingPackage.actual_trip.start_time'>{{ bookingPackage.actual_trip.start_time }}</span>
			</div>
			<!-- trip_booking_resources by trip_booking_package -->
			<dataset-list
				[enableCreate]='data.bookingService.canEdit'
				[elevate]='false'
				[showSearchBar]='false'
				[showTitle]='false'
				datasetCode='trip_booking_resources'
				[parentDatasetACS]='data.tripBookingPackageACS'
				[parentDatasetRS]='data.tripBookingPackageRS'
				[filters]='{ trip_booking_package_id: bookingPackage.id }'
				[selectable]='true'
				(selected)='onSelected($event)'
				tableStyle="style-1"
			></dataset-list>
		</ng-container>
	</ng-container>
		
	<ng-container *ngIf="datasetRS.record.value">
		<div class="trip_booking_resource_services" style="padding: 24px;">
			<dataset-list
				[enableCreate]='data.bookingService.canEdit && datasetRS.record.value.optional == 1'
				[elevate]='false'
				[showSearchBar]='false'
				[showTitle]='false'
				datasetCode='trip_booking_services'
				[parentDatasetACS]='datasetACS'
				[parentDatasetRS]='datasetRS'
				[filters]='{ trip_booking_resource_id: datasetRS.recordId }'
				tableStyle="style-1"
			></dataset-list>
		</div>
	</ng-container>
</div>

<!-- footer -->
<div class="footer"></div>